import { createSlice } from '@reduxjs/toolkit'

import { getPage } from '../../api/client'

const initialState = {
    loading: false,
    categoryNavigation: {
        categories: [],
    },
    ...window.INITIAL_STATE,
    ...window.CATEGORY_CURRENT_PAGE,
}

function fetchPageStart(state) {
    state.loading = true
    state.error = null
}

function fetchPageSuccess(state, action) {
    state.loading = false

    state.facets = action.payload.facets
    state.products = action.payload.products
    state.name = action.payload.name
    state.description = action.payload.description
    state.pagingFilteringContext = action.payload.pagingFilteringContext
    state.id = action.payload.id
    state.categoryBreadcrumb = action.payload.categoryBreadcrumb

    document.title = action.payload.metaTitle ?? document.title
}

function fetchPageError(state, action) {
    const { message } = action.error
    state.error = message
    state.loading = false
}

const slice = createSlice({
    name: 'currentPage',
    initialState,
    reducers: {
        start: fetchPageStart,
        success: fetchPageSuccess,
        error: fetchPageError,
    },
})

export const { start, success, error } = slice.actions

export function fetchPage(url) {
    return async dispatch => {
        try {
            dispatch(start())
            const response = await getPage(url)
            const data = await response.json()

            dispatch(success(data))
        } catch (error) {
            dispatch(error(error))
        }
    }
}

export default slice.reducer
